 
<div class="container text-center">
  <br/>
  <br/>
    <div class="col-lg-11">
        
        
            <div class="dx-fieldset">
            <div class="dx-fieldset-header" *ngIf="sendConfirm"> 
                <h3>{{messageResult}}</h3>
                <div class="dx-fieldset"> 
                        <div class="dx-field">
                          <a [routerLinkActive]="['active']"[routerLink]="['/account']" >Iniciar sesión.</a>
                          
                        </div>
                       
                    </div>
            </div> 
            
            <!-- <div class="text-danger" *ngIf="errorMessage.length!= 0">Usuario o contraseña no valido</div> -->
            </div> 
    </div>
  <!-- <div class="text-danger" *ngIf="errorMessage.length!= 0">Usuario o contraseña no valido</div> -->
    <div class="col-lg-11" *ngIf="!sendConfirm">
       <div class="col-md-6 offset-md-3">
           <form   #theForm="ngForm" action="your action" (submit)="onFormSubmit($event)"
           (keydown.enter)="$event.preventDefault()">
               <div class="dx-fieldset">
                 <div class="dx-fieldset-header"> Actualizar contraseña</div>
                 
               
                <div class="dx-field">
                  <div class="dx-field-label">Contraseña</div>
                  <div class="dx-field-value">
                      <dx-text-box
                          mode="password"
                          [(value)]="creds.newPassword">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="La contraseña es requerida"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
              <div class="dx-field">
                  <div class="dx-field-label">Confirmar contraseña</div>
                  <div class="dx-field-value">
                      <dx-text-box mode="password"  [(value)]="creds.confirmPassword">
                          <dx-validator>
                              <dxi-validation-rule type="required"
                               message="La confirmación de la contraseña es requerida"></dxi-validation-rule>
                              <dxi-validation-rule 
                              type="compare" 
                              [comparisonTarget]="passwordComparison"
                                  message="La contraseña y la confirmación no son iguales"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
                 <div class="dx-fieldset">
                    <dx-validation-summary id="summary"></dx-validation-summary>
                     <!-- <dx-validation-summary id="summary"></dx-validation-summary> --> 
                     <dx-button 
                         id="button"
                         text="Enviar"
                         type="success"  
                         
                         [useSubmitBehavior]="true"
                         [disabled]="theForm.invalid">
                     </dx-button>
                     <!-- (click)="onConfirmPassword()" -->
                 </div>
             </div> 
           </form>
      </div>
     
    </div>
 </div> 
 
 
 
 
  